"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var style_1 = __importDefault(require("./style"));
var ScreenClassResolver_1 = __importDefault(require("../../context/ScreenClassResolver"));
var Hidden = function (_a) {
    var children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            return (0, style_1.default)({
                screenClass: screenClass,
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl,
                // xxl,
            })
                ? null
                : children;
        } }));
};
Hidden.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    // xxl: false,
};
exports.default = Hidden;
//# sourceMappingURL=index.js.map